import React from "react"
import { css, cx } from "emotion"
import { BACKGROUND } from "../constants"

const Card = props => {
  return (
    <div
      {...props}
      className={cx(
        css`
          border-radius: 10px;
          box-shadow: 0 10px 20px 0 ${BACKGROUND};
          background-color: white;
        `,
        props.className,
      )}
    />
  )
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Card.js